import React from "react";
import { Container, Typography, Button, Box, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link, useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    textAlign: "center",
    padding:'20px',
  },
}));

function Home() {
  const classes = useStyles();
  const name = localStorage.getItem("detail");
  return (
    <div>
      <Typography
        variant="h6"
        component="div"
        sx={{ textAlign: "center", fontFamily: "fantasy" }}
      >
        Welcome Back {name}!
      </Typography>
      <Container className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to MERN Stack CRUD
        </Typography>
        <Link to="detail">
        <Button variant="contained" color="primary" className={classes.button}>
          Get Started
        </Button>
        </Link>
      </Paper>
    </Container>
    </div>
  );
}

export default Home;
